import type { LtlQuote } from '../../types/ltl';

const PRICE_TOLERANCE = 0.01;

/**
 * Reconciles a previously selected quote against a fresh set of rates. offerId
 * is unstable between quote calls, so we match on carrierScac + price (within a
 * small float tolerance) + guaranteed flag. Returns the matching new quote, or
 * null when there is no previous selection or no match.
 */
export const reconcileSelection = (previous: LtlQuote | null | undefined, newRates: LtlQuote[]): LtlQuote | null => {
  if (!previous) {
    return null;
  }

  return (
    newRates.find(
      (rate) =>
        rate.carrierScac === previous.carrierScac &&
        rate.isGuaranteed === previous.isGuaranteed &&
        Math.abs(rate.totalCharges - previous.totalCharges) < PRICE_TOLERANCE,
    ) ?? null
  );
};
